import Button from 'components/features/pfm/Button/Button'
import { FC, useCallback, useMemo } from 'react'
import { OnboardingPagePreset } from 'components/features/creditCard/creditCardOnboarding/OnboardingPagePreset/OnboardingPagePreset'
import { Link } from 'react-router-dom'
import { useStoreDispatch, useStoreSelector } from 'helpers/reactReduxHelpers'
import { PatchCCOnboardingPropsAction } from 'components/features/creditCard/creditCardStore/actions'
import moment from 'moment'
import Flex from 'components/atoms/Flex/Flex'
import { INDICATOR_CHECK_STEP } from 'components/features/pfm/StepIndicator/StepIndicator'

export const DeclinedStepPage: FC = () => {

  const dispatch = useStoreDispatch()
  const handleBack = useCallback(() => {
    dispatch(new PatchCCOnboardingPropsAction({
      step: 'offer',
    }))
  }, [dispatch])

  const isLoading = useStoreSelector((state) => state.app.creditCard.patchOnboardingPropsRequest.isLoading)

  const cardOffer = useStoreSelector((state) => state.data.creditCard.onboarding?.offer)

  const daysLeft = useMemo(() => {
    if (!cardOffer) {
      return 0
    }

    return Math.ceil(moment(cardOffer.deadline).diff(moment(), 'days', true))
  }, [cardOffer])

  const cardChild = useMemo(() => (
    <>
      <h2>You’ll have { daysLeft } days to finish if you change your mind.</h2>
      <p>
        If you change your mind, please visit the Credit Card page and apply again.
      </p>
    </>
  ), [daysLeft])


  return (
    <OnboardingPagePreset
      step={ INDICATOR_CHECK_STEP }
      title='Thank you for considering us for your credit needs.'
      card={ cardChild }
      progressPercent={ 100 }
    >
      <Flex fullWidth>
        <Button
          text='Go back to Offer'
          onClick={ handleBack }
          qaMarker='next-button'
          isSubmitting={ isLoading }
          fullWidth
        />
        <Link to='/dashboard'>
          <Button
            text='GO TO YOUR MONEY PAGE'
            style='hollow'
            qaMarker='cancel-button'
            fullWidth
          />
        </Link>
      </Flex>
    </OnboardingPagePreset>
  )
}
